import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import api from 'api/api';
import useVersionInfo from 'hooks/useVersionInfo';

import { CategoryWithSectors, FetchCategoriesParams } from './types';

const fetchCategories = async (params: FetchCategoriesParams) => {
  const response = await api.get<CategoryWithSectors[]>(`web/categories-with-counts`, { params });
  return response.data;
};

const useCategoryData = () => {
  const { ver: version, system_model } = useVersionInfo();
  return useQuery<CategoryWithSectors[], AxiosError>({
    queryKey: ['categories'],
    queryFn: () => fetchCategories({ version, system_model }),
  });
};

export default useCategoryData;
